<!--赖传峰-->
<!--2022/3/18-->
<template>
  <ClientOnly>
    <ElPopover
      v-model:visible="i18nVisible"
      :offset="offset"
      :show-arrow="false"
      :virtual-ref="i18nBtnRef"
      placement="bottom"
      popper-class="pp-toggle-i18n-popover"
      trigger="hover"
      virtual-triggering
      width="160px"
    >
      <I18nMenuList />
    </ElPopover>
  </ClientOnly>
  <a
    ref="i18nBtnRef"
    :data-theme="theme"
    class="pp-link-button"
    style="transition: unset"
  >
    <I18nIcon
      :color="theme === 'light' ? '#fff' : 'var(--color-secondary-text)'"
      style="margin-right: 8px"
    />
    <div class="i18n-current-locale">
      {{ localeName }}
      <DownIcon
        :color="theme === 'light' ? '#ebebf5' : 'var(--color-secondary-text)'"
        :style="arrowIconStyle(i18nVisible)"
      />
    </div>
  </a>
</template>

<script lang="ts" setup>
import { computed, ref, toRefs, useNuxtApp, watch } from '#imports'
import DownIcon from '@/components/icons/DownIcon.vue'
import I18nIcon from '@/components/icons/I18nIcon.vue'
import { useLayout } from '~/store/layout'
import I18nMenuList from './I18nMenuList.vue'

interface Props {
  theme?: 'default' | 'light'
  offset?: number
}

withDefaults(defineProps<Props>(), {
  theme: 'default',
  offset: 22,
  changeRoute: true,
})

const { locale, locales } = useNuxtApp().$i18n

const localeName = computed(() => (locales.value as Locales).find(el => el.code === locale.value)?.name)

const layoutStore = useLayout()
const i18nVisible = toRefs(layoutStore).i18nMenuPopoverVisible

watch(locale, () => {
  // FIXME 未生效
  layoutStore.i18nMenuPopoverVisible = false
})

const arrowIconStyle = (visible: boolean) => ({
  transform: `scale(0.8) rotate(${visible ? '180deg' : 0})`,
  transition: 'transform var(--transition-delay) var(--transition-animation)',
})

const i18nBtnRef = ref<HTMLElement>()
</script>
<style lang="less" scoped>
.pp-link-button {
  &[data-theme='light'] {
    color: #fff !important;
  }
}
</style>

<style lang="less">
@import 'assets/styles/util';

.i18n-current-locale {
  display: flex;
  transition: width var(--transition-delay) var(--transition-animation);
  align-items: center;
  width: 100%;
}

.pp-toggle-i18n-popover {
  --el-popover-padding: 8px;
}
</style>
